import { DisplayColumnsPopupComponent } from "./display-columns-popup/display-columns-popup.component"
import { LoaderComponent } from "./loader/loader.component"
import { PreviewFormsComponent } from "./preview-forms/preview-forms.component"
import { SendEmailPopupComponent } from "./send-email-popup/send-email-popup.component"
import { StudentProfileComponent } from "./student-profile/student-profile.component"
import { ViewEmailPopupComponent } from "./view-email-popup/view-email-popup.component"

export const SharedComponents = [
    SendEmailPopupComponent,
    ViewEmailPopupComponent,
    DisplayColumnsPopupComponent,
    StudentProfileComponent,
    PreviewFormsComponent,
    LoaderComponent
]
export {
    SendEmailPopupComponent,
    ViewEmailPopupComponent,
    DisplayColumnsPopupComponent,
    StudentProfileComponent,
    PreviewFormsComponent,
    LoaderComponent
}